/*eslint-disable*/
import React, { Fragment } from "react";
// react plugin for creating date-time-picker
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "components/CustomButtons/Button.js";
import style from "./ConfirmDialogStyle";

import { Close } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(style);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

export const ConfirmDialog = ({ isOpen, onConfirm, onClose }) => {
  const { t } = useTranslation(["registrationFormDialog"]);

  const classes = useStyles();

  const handleCloseDialog = () => {
    onClose();
  };
  const handleConfirmDialog = () => {
    onConfirm();
    onClose();
  };

  return (
    <Fragment>
      <Dialog
        classes={{
          root: classes.modalRoot,
          paper: classes.modal,
        }}
        open={isOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseDialog}
        aria-labelledby="notice-modal-slide-title"
        aria-describedby="notice-modal-slide-description"
      >
        <DialogTitle
          id="notice-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            simple
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            onClick={handleCloseDialog}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>{t("title")}</h4>
        </DialogTitle>
        <DialogContent
          id="notice-modal-slide-description"
          className={classes.modalBody}
        >
          <p>
            <strong>{t("line1")}</strong>
          </p>
          <p>
            {t("line2")}
            <br />
            {t("line3")}
          </p>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button onClick={handleCloseDialog} color="danger" round>
            {t("cancelButton")}
          </Button>
          <Button onClick={handleConfirmDialog} color="success" round>
            {t("confirmButton")}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};
